import * as types from './mutation_types';

export default {
  [types.AUDIO_DELETE_SET_DELETED] (state, deleted) {
    Object.assign(state, { deleted });
  },

  [types.AUDIO_DELETE_SET_ERROR] (state, error) {
    Object.assign(state, { error });
  },

  [types.AUDIO_DELETE_TOGGLE_LOADING] (state) {
    Object.assign(state, { error: '', isLoading: !state.isLoading });
  },

  [types.AUDIO_DELETE_RESET] (state) {
    Object.assign(state, {
      deleted: null,
      error: '',
      isLoading: false,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/audio/delete/mutations.js